module.exports = __webpack_public_path__ + "media/intro.580b0f11.mp4";